import { gql } from '@apollo/client';

export const FETCH_WEATHER_PROCESS_SCHEMA_PROCESS_VARIABLES = gql`
  query FetchWeatherProcessSchemaProcessVariables(
    $processSchemaFilter: ProcessSchemaFilter
    $variableDataFilter: VariableDataFilter
  ) {
    facility {
      processSchemas(filter: $processSchemaFilter) {
        id
        name
        ... on WeatherProcessSchema {
          weatherSampleGroups {
            sampleRate
            components {
              component
              processVariable {
                type
                id
                name
                displayUnit {
                  id
                  name
                }
                variableData(filter: $variableDataFilter) {
                  data
                }
              }
            }
          }
        }
      }
    }
  }
`;
